import {
  headingStyles
} from "./chunk-YTRDWPHI.js";
import {
  IconButton
} from "./chunk-R7XHNGZL.js";
import {
  FontAwesomeIcon
} from "./chunk-APS5QAFW.js";
import {
  cn
} from "./chunk-LJ5F4WFH.js";

// src/Dialog/Dialog.tsx
import * as React from "react";
import * as DialogPrimitive from "@radix-ui/react-dialog";
var Dialog = DialogPrimitive.Root;
var DialogTrigger = DialogPrimitive.Trigger;
var DialogPortal = DialogPrimitive.Portal;
var DialogClose = DialogPrimitive.Close;
var DialogOverlay = React.forwardRef(({ className, ...props }, ref) => /* @__PURE__ */ React.createElement(
  DialogPrimitive.Overlay,
  {
    ref,
    className: cn(
      [
        "fixed inset-0 z-50 ",
        "fixed inset-0 z-50 bg-black/20",
        "data-[state=open]:animate-in data-[state=open]:fade-in-0",
        "data-[state=closed]:animate-out data-[state=closed]:fade-out-0"
      ],
      className
    ),
    ...props
  }
));
DialogOverlay.displayName = DialogPrimitive.Overlay.displayName;
var DialogContent = React.forwardRef(({ className, overlayClassName, children, ...props }, ref) => /* @__PURE__ */ React.createElement(DialogPortal, null, /* @__PURE__ */ React.createElement(DialogOverlay, { className: overlayClassName }), /* @__PURE__ */ React.createElement(
  DialogPrimitive.Content,
  {
    ref,
    className: cn(
      [
        "fixed left-[50%] top-[50%] translate-x-[-50%] translate-y-[-50%]",
        "z-50 grid w-full rounded-lg border border-neutral bg-surface-white shadow-1 duration-200",
        "data-[state=open]:animate-in data-[state=open]:fade-in-0 data-[state=open]:zoom-in-95 data-[state=open]:slide-in-from-left-1/2 data-[state=open]:slide-in-from-top-[48%]",
        "data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=closed]:zoom-out-95 data-[state=closed]:slide-out-to-left-1/2 data-[state=closed]:slide-out-to-top-[48%]"
      ],
      className
    ),
    ...props
  },
  children,
  /* @__PURE__ */ React.createElement(DialogPrimitive.Close, { asChild: true }, /* @__PURE__ */ React.createElement(
    IconButton,
    {
      size: "sm",
      className: "absolute right-4 top-3 [&_svg]:h-6 [&_svg]:w-6"
    },
    /* @__PURE__ */ React.createElement(FontAwesomeIcon, { name: "xmark:regular", className: "size-6" }),
    /* @__PURE__ */ React.createElement("span", { className: "sr-only" }, "Close")
  ))
)));
DialogContent.displayName = DialogPrimitive.Content.displayName;
var DialogHeader = ({
  className,
  ...props
}) => /* @__PURE__ */ React.createElement(
  "div",
  {
    className: cn("flex flex-col border-b border-neutral p-4", className),
    ...props
  }
);
DialogHeader.displayName = "DialogHeader";
var DialogFooter = ({
  className,
  ...props
}) => /* @__PURE__ */ React.createElement(
  "div",
  {
    className: cn(
      "flex flex-col-reverse p-4 sm:flex-row sm:justify-end sm:space-x-2",
      className
    ),
    ...props
  }
);
DialogFooter.displayName = "DialogFooter";
var DialogTitle = React.forwardRef(({ className, ...props }, ref) => {
  const heading = headingStyles({ variant: "subtitle-1" });
  return /* @__PURE__ */ React.createElement(
    DialogPrimitive.Title,
    {
      ref,
      className: cn(heading, "font-semibold text-neutral-primary", className),
      ...props
    }
  );
});
DialogTitle.displayName = DialogPrimitive.Title.displayName;

export {
  Dialog,
  DialogTrigger,
  DialogPortal,
  DialogClose,
  DialogOverlay,
  DialogContent,
  DialogHeader,
  DialogFooter,
  DialogTitle
};
//# sourceMappingURL=chunk-D3V2WU4H.js.map